import { render, staticRenderFns } from "./ElIcon.vue?vue&type=template&id=7185dcbd"
import script from "./ElIcon.vue?vue&type=script&lang=js"
export * from "./ElIcon.vue?vue&type=script&lang=js"
import style0 from "./ElIcon.vue?vue&type=style&index=0&id=7185dcbd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports